/** Dashed full-width empty-state CTA on profile section cards (skills, about, etc.). */
export const profileSectionEmptyCtaClass =
  'h-auto w-full justify-start border-dashed px-4 py-4 text-muted-foreground'

/** Section header edit pencil — persistent on mobile, hover/focus reveal on desktop. */
export const profileSectionManageButtonClass =
  'shrink-0 opacity-100 transition-opacity md:opacity-0 md:group-hover/section:opacity-100 focus-visible:opacity-100'

/** Stack of experience / education / paper / certification rows inside one section card. */
export const profileSectionItemListClass = 'space-y-6'

/**
 * One row inside a profile section card. Spacing separates entries — do not add nested
 * borders or extra card chrome. Pair with `relative` when overlaying the hover edit control.
 */
export const profileSectionItemClass = 'group/item'

/** Per-row hover edit — overlay so body text uses the full card width (do not reserve a flex column). */
export const profileSectionItemEditButtonClass =
  'absolute right-0 top-0 z-[1] opacity-100 transition-opacity md:opacity-0 md:group-hover/item:opacity-100 focus-visible:opacity-100'
